module.exports = __webpack_public_path__ + "img/builder-23.23ee3f51.webp";